import _sfc_main from "./Avatar.vue2.js";
/* empty css            */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Avatar = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-ded0ccc3"]]);
export {
  Avatar as default
};
//# sourceMappingURL=Avatar.vue.js.map
